<template>
    <transition name="slide-down">
        <div 
            v-if="show" 
            :class="labelClass"
        >
            <span>
                <slot></slot>
            </span>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        show: Boolean,
        labelClass: [String, Array]
    }
}
</script>